import { Analytics } from '../../../analytics/sendAnalyticsEvent';

const makeItemInfo = (itemId, basePrice, quantity) => {
  return ([{
    quantity,
    productInfo: {
      sku: String(itemId)
    },
    price: {
      basePrice: basePrice * quantity
    }
  }]);
};

const sendOverlayEventNameAnalytics = (eventName) => {
  const thdAnalyticsEvent = {
    category: {
      primaryCategory: 'overlay'
    },
    eventInfo: {
      eventName
    },
  };
  Analytics.sendAnalyticsEvent(thdAnalyticsEvent);
};

export const sendButtonSubmissionAnalytics = (eventName, itemInfo) => {
  const thdAnalyticsEvent = {
    category: {
      primaryCategory: 'button submission'
    },
    eventInfo: {
      eventName
    },
    item: [itemInfo]
  };
  Analytics.sendAnalyticsEvent(thdAnalyticsEvent);
};

export const sendHowItWorksAnalytics = () => {
  sendOverlayEventNameAnalytics('cabinet configurator - how it works');
};

export const sendAddWallAnalytics = () => {
  sendOverlayEventNameAnalytics('cabinet configurator - add wall');
};

export const sendInteractionAnalytics = (component, section, target) => {
  const thdAnalyticsEvent = {
    category: {
      primaryCategory: 'interaction'
    },
    eventInfo: {
      eventName: 'pip sub-content'
    },
    subContent: {
      component,
      section,
      target
    }
  };
  Analytics.sendAnalyticsEvent(thdAnalyticsEvent);
};

export const sendRemoveItemFromWallAnalytics = (target) => {
  sendInteractionAnalytics('remove item', 'cabinet wall', target);
};

export const sendEditCabinetAnalytics = (removedItemId, cabinetInfo, itemPrices) => {
  sendInteractionAnalytics('edit item', 'cabinet wall', 'edit item link');

  const removedItemPrice = itemPrices.find((item) => item.itemId === removedItemId);
  const removedItemBasePrice = String(removedItemPrice?.price) || '0';
  const removedItemInfo = makeItemInfo(removedItemId, removedItemBasePrice, 1);
  sendButtonSubmissionAnalytics('bundle remove', removedItemInfo);

  const addedItemId = +cabinetInfo?.itemId || removedItemId;
  const addedItemPrice = itemPrices.find((item) => item.itemId === addedItemId);
  const addedItemBasePrice = String(addedItemPrice?.price) || '0';
  const addedItemInfo = makeItemInfo(addedItemId, addedItemBasePrice, 1);
  sendButtonSubmissionAnalytics('bundle add', addedItemInfo);
};

export const sendRemoveAnalytics = (itemInfo, target = null) => {
  // If itemInfo is not provided, we cannot send item data
  if (!itemInfo || itemInfo.length === 0) {
    return;
  }
  if (target != null) { sendRemoveItemFromWallAnalytics(target); }
  sendButtonSubmissionAnalytics('bundle remove', itemInfo);
};

export const sendWallSummarylAnalytics = () => {
  sendOverlayEventNameAnalytics('wall summary');
};

export const sendQuickViewOpenlAnalytics = () => {
  sendOverlayEventNameAnalytics('pip quick view');
};